// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum ClientProfileNoteProp {
	CustomerId = 'customerId',
	CustomerId$name = 'customerId$name',
	Id = 'id',
	Summary = 'summary'
}

export type ClientProfileNotePropCustomerId = {
	[ClientProfileNoteProp.CustomerId] : number | null
}
export type ClientProfileNotePropCustomerId$name = {
	[ClientProfileNoteProp.CustomerId$name] : number | null
}
export type ClientProfileNotePropId = {
	[ClientProfileNoteProp.Id] : number
}
export type ClientProfileNotePropSummary = {
	[ClientProfileNoteProp.Summary] : string | null
}


export type ClientProfileNote = 
	ClientProfileNotePropCustomerId & 
	ClientProfileNotePropCustomerId$name & 
	ClientProfileNotePropId & 
	ClientProfileNotePropSummary

export const CLIENT_PROFILE_NOTE_PROPERTY_NAMES = Object.freeze([ClientProfileNoteProp.CustomerId, ClientProfileNoteProp.CustomerId$name, ClientProfileNoteProp.Id, ClientProfileNoteProp.Summary])

export type ClientProfileNoteCreate = 
	ClientProfileNotePropCustomerId & 
	ClientProfileNotePropSummary

export const CLIENT_PROFILE_NOTE_CREATE_PROPERTY_NAMES = Object.freeze([ClientProfileNoteProp.CustomerId, ClientProfileNoteProp.Summary])

export type ClientProfileNoteHistoryTab = 
	ClientProfileNotePropId & 
	ClientProfileNotePropCustomerId & 
	ClientProfileNotePropCustomerId$name

export const CLIENT_PROFILE_NOTE_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([ClientProfileNoteProp.Id, ClientProfileNoteProp.CustomerId, ClientProfileNoteProp.CustomerId$name])
